import { observable } from 'mobx';
import axios from 'axios'

import { mobileApiUrl } from '../../config'

class MapStore {
  @observable carsList = []
  @observable fiteredCarsList = []
  @observable showCars = null

  filterCars = status => {
    this.showCars = status
    if(status == null){
      this.fiteredCarsList = []
    } else {
      const fiteredCarsList = this.carsList.filter( car => {
        if(car.callsign_status === status){
          return true
        }
        return false
      })
      this.fiteredCarsList = fiteredCarsList
    }    
  }

  getCars = () => {
    axios.get(`${mobileApiUrl}getauto.php?func=GetAutoInfo&fields=st%2Ccr%2Ccl%2Cc%2Cm%2Cx%2Cy`)
    .then( response => {
      const carsArr = [...response.data.d]
      const readyCarsArr = carsArr.map( car => {
        let carStatusForMarkers = 8
        if(car.cl === 2){
          carStatusForMarkers = 2
        } else if(car.cl === 1){
          carStatusForMarkers = 6
        } else if(car.cl === 5){
          carStatusForMarkers = 1
        }

        if(car.st === 1){
          carStatusForMarkers = 3
        }
        return {
          callsign: car.cr,
          callsign_status: carStatusForMarkers,
          gps: {
            type: 'Point',
            coordinates: [
              car.x,
              car.y,
            ]
          },
          car: {
            color: car.c,
            brand: car.m,
            car_class: car.cl
          },
        }
      })
      this.carsList = readyCarsArr
      })
    .catch( errs => {
      console.log(errs)
    })
  }

}

export default new MapStore();